import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {tap} from 'rxjs/operators';
import { merge } from 'es-toolkit';
import {environment} from '../../environments/environment';
import {BaseService} from '../../../../shared/src/lib/services/base.service';
import {GenericModalComponent} from '../../../../shared/src/lib/modals/generic-modal/generic-modal.component';

@Injectable({
  providedIn: 'root'
})
export class ContactsService extends BaseService {
  public items: any[] = [];
  public item: any = {};
  public meta: any = {
    verbose_name: 'Contacts',
    type: 'sites/contacts',
    foreign_key_field: 'sites',
    display_fields: ['contact_display_name', 'contact_contact_type'],
    // display_fields: [
    //   'contact_type', 'first_name', 'last_name', 'title', 'contact_uin', 'division_name', 'phone_number', 'alternate_phone', 'fax_number',
    //   'email_address', 'source_of_data', 'address_line_1', 'address_line_2', 'city', 'state', 'zip_code', 'country',
    //   'org_name', 'org_uin', 'org_type', 'duns_number', 'org_ein', 'state_business_id', 'owner_percent'
    // ],
    fields: {
      contact_first_name: {
        get_choices: (s) => this.get_choices(s),
        select_choice: (s, i) => this.select_choice(s, i),
        clear_choice: (m, i) => this.clear_choice(m, i),
        choices: null
      },
      contact_org_name: {
        get_choices: (s) => this.get_choices(s),
        select_choice: (s, i) => this.select_choice(s, i),
        choices: null
      }
    }
  };
  public filters: string[] = [];
  public nonfilterableFields: string[] = ['display_name'];
  public searchParams: any = {
    ordering: ''
  };
  public organization_display_fields: string[] = ['contact_org_name', 'contact_org_type', 'contact_org_uin', 'contact_duns_number',
    'contact_org_ein', 'contact_state_business_id', 'contact_owner_percent', 'contact_phone_number',
    'contact_alternate_phone', 'contact_fax_number', 'contact_email_address', 'contact_address_line_1', 'contact_address_line_2',
    'contact_city', 'contact_state', 'contact_zip_code', 'contact_country', 'contact_source_of_data'];
  public individual_display_fields: string[] = ['contact_first_name', 'contact_last_name', 'contact_title', 'contact_division_name',
    'contact_contact_uin', 'contact_phone_number', 'contact_alternate_phone', 'contact_fax_number',
    'contact_email_address', 'contact_address_line_1', 'contact_address_line_2', 'contact_city', 'contact_state',
    'contact_zip_code', 'contact_country', 'contact_source_of_data'];
  public contact_inline_display_fields: string[] = [
    'contact_display_name', 'contact_contact_type', 'contact_phone_number', 'contact_alternate_phone'
  ];

  constructor(http: HttpClient, private modalService: NgbModal) {
    super(`${environment.baseUrl}/contactmanager`, http);
  }


  public loadData(id) {

    return this.getList({search: id.replace('{', '').replace('}', '')}).pipe(
      tap(contacts => {
        merge(this.items, contacts.results);
        merge(this.meta, contacts.meta);
        this.meta.display_fields = [
          'contact_type', 'first_name', 'last_name', 'title', 'contact_uin', 'division_name', 'phone_number', 'alternate_phone', 'fax_number',
          'email_address', 'source_of_data', 'address_line_1', 'address_line_2', 'city', 'state', 'zip_code', 'country',
          'org_name', 'org_uin', 'org_type', 'duns_number', 'org_ein', 'state_business_id', 'owner_percent'
        ];
        // this.meta.type = 'contacts';
        this.meta.affiliation = 'true';
      })
    );
  }

  public getContact(globalid) {
    this.get<any>(globalid).pipe(tap(contact => {
      this.item = contact.result;
      merge(this.meta, contact.meta);
      this.meta.display_fields = [
        'contact_type', 'first_name', 'last_name', 'title', 'contact_uin', 'division_name', 'phone_number', 'alternate_phone', 'fax_number',
        'email_address', 'source_of_data', 'address_line_1', 'address_line_2', 'city', 'state', 'zip_code', 'country',
        'org_name', 'org_uin', 'org_type', 'duns_number', 'org_ein', 'state_business_id', 'owner_percent'
      ];
      // this.meta.type = 'contacts';
      this.meta.affiliation = 'true';
    }));
  }

  public search() {
    this.searchParams.ordering = this.filters.join(',');
    return this.getList(this.searchParams).pipe(tap(response => {
        this.items = response.results;
        merge(this.meta, response.meta);
      })
    );
  }

  public deleteContact(contact) {
    const confirmDialog = this.modalService.open(GenericModalComponent);
    confirmDialog.componentInstance.title = 'Please Confirm';
    confirmDialog.componentInstance.text = `Are you sure you want to delete <b>${contact.display_name}? </b>`;
    // confirmDialog.result.then(function () {

  }

  public get_choices(searchObj): Promise<any[]> {
    return new Promise(resolve => {
      this.getList({search: searchObj}).pipe(tap(response => {
        resolve(response.results);
      })).subscribe();
    });
  }

  public select_choice(selected, item) {
    Object.keys(selected).forEach(key => item[`contact_${key}`] = selected[key]);
  }

  public clear_choice(meta, item) {
    Object.keys(meta.fields)
      .filter(f => !['contact_contact_type', meta.foreign_key_field, 'globalid'].includes(f))
      .forEach(field => {
        item[field] = null;
      });
  }
}
